const stringContains = (haystack, needle, caseSensitive) => {
    if (!haystack) {
        return false;
    }
    if (!needle) {
        return true;
    }
    if (caseSensitive) {
        return haystack.indexOf(needle) > -1;
    }
    return haystack.toLowerCase().indexOf(needle.toLowerCase()) > -1;
};
const stringEquals = (haystack, needle, caseSensitive) => {
    if (!haystack) {
        return false;
    }
    if (!needle) {
        return true;
    }
    if (caseSensitive) {
        return haystack === needle;
    }
    return haystack.toLowerCase() === needle.toLowerCase();
};
export { stringEquals, stringContains };
//# sourceMappingURL=index.js.map